import { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, Typography, TextField } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PageService from '../../services/PageService'

const CreatePresetModal = ({
  projectId,
  createPresetOpen,
  setCreatePresetOpen,
  pagesToggler,
  setPagesToggler,
  checkedPages,
  setCheckedPages
}) => {
  const [name, setName] = useState('')
  const [nameError, setNameError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleCloseDialog = () => {
    setCreatePresetOpen(false)
  }

  const handleNameChange = (e) => {
    setName(e.target.value)

    if (nameError) {
      setNameError('')
    }
  }

  const handleCreatePreset = async () => {
    if (!name.trim()) {
      setNameError('Name is required.')
      return
    } else {
      setNameError('')
    }

    try {
      setLoading(true)
      await PageService.createPreset(name, projectId, checkedPages)
      setCheckedPages([])
      setName('')
      setPagesToggler(!pagesToggler)
      setCreatePresetOpen(false)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={createPresetOpen} onClose={handleCloseDialog}>
      <Box className="createPresetModal">
        <DialogTitle className="createPresetModalTitle">
          Create Selection Preset
        </DialogTitle>
        <DialogContent className="createPresetModalContent">
          <Typography variant='body1' mb={2}>
            Please enter the name of selection preset
          </Typography>
          <TextField
            label="Preset Name *"
            type="text"
            fullWidth
            variant="outlined"
            value={name}
            onChange={handleNameChange}
            error={!!nameError}
            helperText={nameError + ' '}
          />
        </DialogContent>
        <DialogActions className="createPresetModalActions">
          <Button className="createPresetModalButton" onClick={handleCloseDialog} color="secondary" variant="outlined">
            CANCEL
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="createPresetModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="createPresetModalButton" onClick={handleCreatePreset} color="secondary" variant="contained" autoFocus>
              SAVE
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default CreatePresetModal